import { createDateRangeFilter } from '@spotify/confidence-core-react';

export const PLANNED_START_TIME_FILTER = createDateRangeFilter({
  id: 'plannedStartTime',
  label: 'Planned start',
  field: 'module_data.planning.planned.startTime',
});

export const PLANNED_END_TIME_FILTER = createDateRangeFilter({
  id: 'plannedEndTime',
  label: 'Planned end',
  field: 'module_data.planning.planned.endTime',
});

export const ACTUAL_START_TIME_FILTER = createDateRangeFilter({
  id: 'actualStartTime',
  label: 'Started',
  field: 'module_data.planning.actual.startTime',
});

export const ACTUAL_END_TIME_FILTER = createDateRangeFilter({
  id: 'actualEndTime',
  label: 'Ended',
  field: 'module_data.planning.actual.endTime',
});
